import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetLeadConfigurationRequest extends ValueObject {
  #makeId
  #variationKey

  constructor({makeId, variationKey}) {
    super()
    this.#makeId = makeId
    this.#variationKey = variationKey
  }

  static validate({makeId}) {
    if (!makeId)
      throw InvalidParamsSharedError.create('[GetLeadConfigurationRequest.validate] param makeId is required')
  }

  static create({makeId, variationKey}) {
    GetLeadConfigurationRequest.validate({makeId})
    return new GetLeadConfigurationRequest({makeId, variationKey})
  }

  get makeId() {
    return this.#makeId
  }

  get variationKey() {
    return this.#variationKey
  }

  toJSON() {
    return {
      makeId: this.#makeId,
      variationKey: this.#variationKey
    }
  }
}
